const normalizeColor = (color: string | undefined): string =>
  typeof color === 'string' ? color.toUpperCase() : '';

export const resolveColorsPalette = (
  colors: string[],
  currentColor: string | undefined,
  /** Maximum number of colors to return */
  maxColors = 58 // 6×10 grid - 1 add button - 1 empty slot for new color
): string[] => {
  const colorSet = new Set(colors.map(normalizeColor).filter(color => color !== ''));
  const normalizedCurrent = normalizeColor(currentColor);
  return normalizedCurrent === '' || colorSet.has(normalizedCurrent)
    ? Array.from(colorSet).slice(0, maxColors)
    : [...Array.from(colorSet).slice(0, maxColors - 1), normalizedCurrent];
};
